module.exports = __webpack_public_path__ + "img/img_view_direct_lg_01.c2d7b048.png";